import { render } from "./ForgetPasswordSet.vue?vue&type=template&id=3b0f896c&ts=true"
import script from "./ForgetPasswordSet.vue?vue&type=script&lang=ts"
export * from "./ForgetPasswordSet.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__